import { Component } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TsButtonModule } from 'tsui';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

declare type SumOrAvg = 'sum' | 'avg';

@Component({
  standalone: true,
  imports: [MatIconModule, TsButtonModule, MatMenuModule, TitleCasePipe],
  selector: 'table-footer-agg-renderer',
  template: `
    <div class="footer-agg">
      @if (params.colDef.field !== 'column_0') {
        <span>{{ operation ?? 'Sum' | titlecase }}:</span>
        <span>{{ params.value }}</span>
        <button mat-icon-button [matMenuTriggerFor]="aggMenu">
          <mat-icon [svgIcon]="'expand_more'" class="icon-size-12"></mat-icon>
        </button>
        <mat-menu #aggMenu="matMenu">
          <button mat-menu-item (click)="toggleAgg('sum')">Sum</button>
          <button mat-menu-item (click)="toggleAgg('avg')">Avg</button>
        </mat-menu>
      }
    </div>
  `,
  styles: [
    `
      .footer-agg {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    `,
  ],
})
export class TableFooterAggRendererComponent implements ICellRendererAngularComp {
  params: any;
  operation: SumOrAvg;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.operation = this.params.context.panelDef.meta?.footer[this.params.column.instanceId];
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return false;
  }

  toggleAgg(operation: SumOrAvg): void {
    if (this.params.context && this.params.context.toggleAgg) {
      this.params.context.toggleAgg(this.params.column.colId, operation);
      this.operation = operation;
    }
  }
}
